import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
* Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 사용자 메일 인증 성공 -고도화 개발
 *
 ********************************************************************/
import React from "react";
import { useNavigate } from "react-router-dom";
import * as CONST from "../../../utils/Const";
function OkEhpCertification() {
    const navigate = useNavigate();
    // console.log("localtion", location.pathname);
    function LoginGo(e) {
        // navigate(CONST.URL_LOGIN)
        navigate(CONST.URL_LOGIN);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "login__right webmailok" }, { children: [_jsx("h2", { children: _jsx("p", Object.assign({ className: "tit" }, { children: "\uC778\uC99D \uC644\uB8CC" })) }), _jsx("div", Object.assign({ className: "login__form" }, { children: _jsx("form", Object.assign({ action: "#", method: "", name: "loginform" }, { children: _jsxs("fieldset", { children: [_jsx("p", Object.assign({ className: "login__info" }, { children: "\uBA54\uC77C \uC778\uC99D\uC774 \uC815\uC0C1\uC801\uC73C\uB85C \uC644\uB8CC \uB418\uC5C8\uC2B5\uB2C8\uB2E4." })), _jsx("button", Object.assign({ type: "button", className: "btn-login js-open", "data-pop": "pop-login", onClick: (e) => LoginGo(e) }, { children: _jsx("span", { children: "\uB85C\uADF8\uC778\uD558\uAE30" }) }))] }) })) }))] })) }));
}
export default OkEhpCertification;
